/** @prettier */
import ReactApexChart from 'react-apexcharts';
import {individualSiteBarGraphSetting} from './graph/setting/bar/individualSiteBarGraphSetting';
import {individualUnitBarGraphSetting} from './graph/setting/bar/individualUnitBarGraphSetting';
import {aggregationQtonHyozanBarGraphSetting} from './graph/setting/bar/aggregationQtonHyozanBarGraphSetting';
import {aggregationUnitBarGraphSetting} from './graph/setting/bar/aggregationUnitBarGraphSetting';
import {aggregationSiteBarGraphSetting} from './graph/setting/bar/aggregationSiteBarGraphSetting';

import {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

//type import
import {GraphDataRange, GraphTargetType} from '../Type/TypeDef';
import {aggregationChillerBarGraphSetting} from './graph/setting/bar/aggregationChillerBarGraphSetting';
import {specialID} from '../define';

// class StackBarChart extends React.Component {
//   constructor(props) {
//     super(props);

//     //グラフモードが冷暖他表示の場合
//     if (props.graphMode === 'Individual') {
//       //サイト単位とそれ以外でグラフの表示が異なる
//       if (props.graphTarget !== 'site') {
//         this.state = individualUnitBarGraphSetting(props);
//       } else {
//         this.state = individualSiteBarGraphSetting(props);
//       }
//     } else {
//       //グラフモードがSL/RT表示の場合
//       //サイト単位、Q-tonHyozan、それ以外でグラフの表示が異なる
//       if (props.graphTarget === 'qton' || props.graphTarget === 'hyozan') {
//         this.state = aggregationQtonHyozanBarGraphSetting(props);
//       } else if (props.graphTarget !== 'site') {
//         this.state = aggregationUnitBarGraphSetting(props);
//       } else {
//         this.state = aggregationSiteBarGraphSetting(props);
//       }
//     }
//   }

//   componentDidUpdate(prevProps) {
//     if (prevProps !== this.props) {
//       if (this.props.graphMode === 'Individual') {
//         //サイト単位とそれ以外でグラフの表示が異なる
//         if (this.props.graphTarget !== 'site') {
//           this.setState(individualUnitBarGraphSetting(this.props));
//         } else {
//           this.setState(individualSiteBarGraphSetting(this.props));
//         }
//       } else {
//         //グラフモードがSL/RT表示の場合
//         //サイト単位、Q-tonHyozan、それ以外でグラフの表示が異なる
//         if (
//           this.props.graphTarget === 'qton' ||
//           this.props.graphTarget === 'hyozan'
//         ) {
//           this.setState(aggregationQtonHyozanBarGraphSetting(this.props));
//         } else if (this.props.graphTarget !== 'site') {
//           this.setState(aggregationUnitBarGraphSetting(this.props));
//         } else {
//           this.setState(aggregationSiteBarGraphSetting(this.props));
//         }
//       }
//     }
//   }
//   render() {
//     return (
//       <div id="chart">
//         <ReactApexChart
//           options={this.state.options}
//           series={this.state.series}
//           type="bar"
//           height={700}
//         />
//       </div>
//     );
//   }
// }

/**
 * 消費電力グラフ
 * @param props props
 * @returns JSX
 */
const BarChartGraph = (props: {
  graphMode: 'Individual' | 'Aggregation'; //表示形式
  graphTarget: GraphTargetType; //表示する対象
  xLabel: string[]; //X軸のラベル
  dateRange: GraphDataRange; //データ取得範囲
  csvFileNameDate: string; //CSVファイルの名前（日付部分）
  csvFileNameTarget: string; //CSVファイルの名前（サイトの名前 + グラフの対象の名前）
  barGraphData1: ApexAxisChartSeries['0']['data']; //積み上げグラフ一段目
  barGraphData2?: ApexAxisChartSeries['0']['data']; //積み上げグラフ二段目
  barGraphData3?: ApexAxisChartSeries['0']['data']; //積み上げグラフ三段目
  barGraphData4?: ApexAxisChartSeries['0']['data']; //積み上げグラフ四段目
  barGraphData5?: ApexAxisChartSeries['0']['data']; //積み上げグラフ五段目
  comparisonBarGraphData1?: ApexAxisChartSeries['0']['data']; //積み上げグラフ一段目(別の日)
  comparisonBarGraphData2?: ApexAxisChartSeries['0']['data']; //積み上げグラフ二段目(別の日)
  comparisonBarGraphData3?: ApexAxisChartSeries['0']['data']; //積み上げグラフ三段目(別の日)
  comparisonBarGraphData4?: ApexAxisChartSeries['0']['data']; //積み上げグラフ四段目(別の日)
  comparisonBarGraphData5?: ApexAxisChartSeries['0']['data']; //積み上げグラフ五段目（別の日）
  //  ----------------------- |  individualSite  |  individualUnit  |  aggregationSite       |  aggregationQtonHyozan   | aggregationChiller  |
  //  barGraphData1           |  AC Cool         |  AC Cool         | AC(Cool+Hot+Other)     |  RT Cool or RT Hot       | RT Cool             |
  //  barGraphData2           |  AC Hot          |  AC Hot          | No Data                |  No Data                 | RT Hot              |
  //  barGraphData3           |  AC Other        |  AC Other        | No Data                |  No Data                 | No Data             |
  //  barGraphData4           |  RT Cool         |  No Data         | RT                     |  No Data                 | No Data             |
  //  barGraphData5           |  RT Hot          |  No Data         | No Data                |  No Data                 | No Data             |
  //  ComparisonBarGraphData1 |  AC Cool(※)     |  AC Cool(※)     | AC(Cool+Hot+Other)(※) |  RT Cool(※) or RT Hot(※)| RT Cool(※)         |
  //  ComparisonBarGraphData2 |  AC Hot(※)      |  AC Hot(※)      | No Data                |  No Data                 | RT Hot(※)          |
  //  ComparisonBarGraphData3 |  AC Other(※)    |  AC Other(※)    | No Data                |  No Data                 | No Data             |
  //  ComparisonBarGraphData4 |  RT Cool(※)     |  No Data         | RT(※)                 |  No Data                 | No Data             |
  //  ComparisonBarGraphData5 |  RT Hot(※)      |  No Data         | No Data                |  No Data                 | No Data             |
  //  RT = qton(Hot)+hyozan(Cool)+hccvq(cool), (※)はCOMPARISONボタン押下時に表示される別の日のグラフのデータ
}) => {
  const [chartArg, setChartArg] = useState<{
    options: ApexCharts.ApexOptions;
    series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  } | null>(null);

  const trans = useTranslation().t; //翻訳関数

  /**
   * 与えられたデータ配列を変換する関数
   * 0の値をnullに置き換え、それ以外の値をそのまま返す
   *
   * @param data - 処理するデータの配列
   * @returns  クリーニングされたデータの配列
   */
  function cleanData(
    data: ApexAxisChartSeries['0']['data']
  ): (number | null)[] {
    //型エラーが回避できないので暫定対応でアノテーションを実施
    return data.map(value => (value === 0 ? null : (value as number)));
  }

  useEffect(() => {
    if (props.graphMode === 'Individual') {
      //グラフモードが冷暖他表示の場合
      if (props.graphTarget === 'site') {
        //サイト単位
        setChartArg(
          individualSiteBarGraphSetting({
            xLabel: props.xLabel,
            dateRange: props.dateRange,
            csvFileNameDate: props.csvFileNameDate,
            csvFileNameTarget: props.csvFileNameTarget,
            barGraphDataCool: cleanData(props.barGraphData1),
            barGraphDataHot:
              props.barGraphData2 === undefined
                ? []
                : cleanData(props.barGraphData2),
            barGraphDataOther:
              props.barGraphData3 === undefined
                ? []
                : cleanData(props.barGraphData3),
            barGraphDataRTCool:
              props.barGraphData4 === undefined
                ? []
                : cleanData(props.barGraphData4),
            barGraphDataRTHot:
              props.barGraphData5 === undefined
                ? []
                : cleanData(props.barGraphData5),
            comparisonBarGraphDataCool:
              props.comparisonBarGraphData1 === undefined
                ? []
                : cleanData(props.comparisonBarGraphData1),
            comparisonBarGraphDataHot:
              props.comparisonBarGraphData2 === undefined
                ? []
                : cleanData(props.comparisonBarGraphData2),
            comparisonBarGraphDataOther:
              props.comparisonBarGraphData3 === undefined
                ? []
                : cleanData(props.comparisonBarGraphData3),
            comparisonBarGraphDataRTCool:
              props.comparisonBarGraphData4 === undefined
                ? []
                : cleanData(props.comparisonBarGraphData4),
            comparisonBarGraphDataRTHot:
              props.comparisonBarGraphData5 === undefined
                ? []
                : cleanData(props.comparisonBarGraphData5),
            trans: trans,
          })
        );
      } else {
        //サイト単位以外
        setChartArg(
          individualUnitBarGraphSetting({
            xLabel: props.xLabel,
            dateRange: props.dateRange,
            csvFileNameDate: props.csvFileNameDate,
            csvFileNameTarget: props.csvFileNameTarget,
            barGraphDataCool: props.barGraphData1,
            barGraphDataHot:
              props.barGraphData2 === undefined
                ? []
                : cleanData(props.barGraphData2),
            barGraphDataOther:
              props.barGraphData3 === undefined
                ? []
                : cleanData(props.barGraphData3),
            comparisonBarGraphDataCool:
              props.comparisonBarGraphData1 === undefined
                ? []
                : cleanData(props.comparisonBarGraphData1),
            comparisonBarGraphDataHot:
              props.comparisonBarGraphData2 === undefined
                ? []
                : cleanData(props.comparisonBarGraphData2),
            comparisonBarGraphDataOther:
              props.comparisonBarGraphData3 === undefined
                ? []
                : cleanData(props.comparisonBarGraphData3),
            trans: trans,
          })
        );
      }
    } else if (props.graphMode === 'Aggregation') {
      //グラフモードが個別表示の場合
      switch (props.graphTarget) {
        //グラフ描画対象がサイト全体の場合
        case 'site':
          setChartArg(
            aggregationSiteBarGraphSetting({
              xLabel: props.xLabel,
              dateRange: props.dateRange,
              csvFileNameDate: props.csvFileNameDate,
              csvFileNameTarget: props.csvFileNameTarget,
              barGraphDataAC: cleanData(props.barGraphData1),
              barGraphDataRT:
                props.barGraphData4 === undefined
                  ? []
                  : cleanData(props.barGraphData4),
              comparisonBarGraphDataAC:
                props.comparisonBarGraphData1 === undefined
                  ? []
                  : cleanData(props.comparisonBarGraphData1),
              comparisonBarGraphDataRT:
                props.comparisonBarGraphData4 === undefined
                  ? []
                  : cleanData(props.comparisonBarGraphData4),
              trans: trans,
            })
          );
          break;
        //グラフ描画対象がQ-tonの場合
        case 'qton':
          setChartArg(
            aggregationQtonHyozanBarGraphSetting({
              xLabel: props.xLabel,
              dateRange: props.dateRange,
              graphTarget: props.graphTarget,
              csvFileNameDate: props.csvFileNameDate,
              csvFileNameTarget: props.csvFileNameTarget,
              barGraphPowerConsumption: cleanData(props.barGraphData1),
              comparisonBarGraphPowerConsumption:
                props.comparisonBarGraphData1 === undefined
                  ? []
                  : cleanData(props.comparisonBarGraphData1),
              trans: trans,
            })
          );
          break;
        //グラフ描画対象がHCCV(Q)の場合
        case 'hyozan': //fall through
        case 'modbus': //fall through
          setChartArg(
            aggregationQtonHyozanBarGraphSetting({
              xLabel: props.xLabel,
              dateRange: props.dateRange,
              graphTarget: props.graphTarget,
              csvFileNameDate: props.csvFileNameDate,
              csvFileNameTarget: props.csvFileNameTarget,
              barGraphPowerConsumption: cleanData(props.barGraphData1),
              comparisonBarGraphPowerConsumption:
                props.comparisonBarGraphData1 === undefined
                  ? []
                  : cleanData(props.comparisonBarGraphData1),
              trans: trans,
            })
          );
          break;
        //グラフ描画対象がChillerの場合
        case 'chiller':
          setChartArg(
            aggregationChillerBarGraphSetting({
              xLabel: props.xLabel,
              dateRange: props.dateRange,
              csvFileNameDate: props.csvFileNameDate,
              csvFileNameTarget: props.csvFileNameTarget,
              barGraphPowerConsumptionCool: cleanData(props.barGraphData1),
              barGraphPowerConsumptionHot:
                props.barGraphData2 === undefined
                  ? []
                  : cleanData(props.barGraphData2),
              comparisonBarGraphPowerConsumptionCool:
                props.comparisonBarGraphData1 === undefined
                  ? []
                  : cleanData(props.comparisonBarGraphData1),
              comparisonBarGraphPowerConsumptionHot:
                props.comparisonBarGraphData2 === undefined
                  ? []
                  : cleanData(props.comparisonBarGraphData2),
              trans: trans,
            })
          );
          break;
        default:
          setChartArg(
            aggregationUnitBarGraphSetting({
              xLabel: props.xLabel,
              dateRange: props.dateRange,
              csvFileNameDate: props.csvFileNameDate,
              csvFileNameTarget: props.csvFileNameTarget,
              barGraphData: props.barGraphData1,
              comparisonBarGraphData:
                props.comparisonBarGraphData1 === undefined
                  ? []
                  : props.comparisonBarGraphData1,
              trans: trans,
            })
          );
      }
    }
  }, [props]);

  if (chartArg === null) return <></>;
  return (
    <ReactApexChart
      id={specialID.IGNORE_INTERACTJS_ID}
      options={chartArg.options}
      series={chartArg.series}
      type="bar"
      height="80%"
    />
  );
};

export default BarChartGraph;
